import * as Yup from "yup";

/**
 * Schema de validação para Financial Records.
 * 
 * Contrato de datas:
 * - Datas de calendário (issueDate, competenceDate, dueDate, paymentDate, cancellationDate)
 *   são SEMPRE strings "YYYY-MM-DD", NUNCA Date JS ou Timestamp.
 * - Datas de auditoria (createdAt, updatedAt) são Timestamp nativos do Firebase (tratados no converter).
 */
export const financialRecordSchema = Yup.object().shape({
    idSale: Yup.string().nullable(),

    type: Yup.string().oneOf(["ASSET", "LIABILITY"]).required("Classificação de Ativo/Passivo obrigatória"),
    
    idCategory: Yup.string().required("Vincule este lançamento a uma conta/categoria (Ex: Mensalidades/Luz)"),
    categoryName: Yup.string().nullable(),

    sourceType: Yup.string().oneOf(["MEMBER", "ACQUIRER", "SUPPLIER", "EMPLOYEE"]).required("De onde vem ou para quem vai este dinheiro?"),
    idEntity: Yup.string().required("Especifique a pessoa ou empresa envolvida nesta transação"),
    entityName: Yup.string().nullable(),

    idMember: Yup.string().nullable(),
    memberName: Yup.string().nullable(),
    idEmployee: Yup.string().nullable(),
    employeeName: Yup.string().nullable(),

    // Cálculos de Dinheiro (Permitem zeros, mas não vazios)
    grossAmount: Yup.number().min(0, "O Valor Bruto não pode ser negativo").required("Valor Bruto é obrigatório"),
    feePercentage: Yup.number().min(0).max(100).default(0),
    feeAmount: Yup.number().min(0).default(0),
    discount: Yup.number().min(0).default(0),
    fineAndInterest: Yup.number().min(0).default(0),
    netAmount: Yup.number().required("O Valor Líquido do repasse deve ser calculado"),

    // Datas de Calendário — string "YYYY-MM-DD" conforme contrato
    issueDate: Yup.string()
        .matches(/^\d{4}-\d{2}-\d{2}$/, "Formato de data inválido (YYYY-MM-DD)")
        .required("Data de emissão obrigatória"),
    competenceDate: Yup.string()
        .matches(/^\d{4}-\d{2}-\d{2}$/, "Formato de data inválido (YYYY-MM-DD)")
        .required("Data de competência é obrigatória para relatórios contábeis"),
    dueDate: Yup.string()
        .matches(/^\d{4}-\d{2}-\d{2}$/, "Formato de data inválido (YYYY-MM-DD)")
        .required("Data de vencimento/repasse é obrigatória para o Fluxo de Caixa"),
    
    // Pode ser null caso status === PENDING ou OVERDUE
    paymentDate: Yup.string()
        .matches(/^\d{4}-\d{2}-\d{2}$/, "Formato de data inválido (YYYY-MM-DD)")
        .nullable()
        .when('status', {
            is: 'PAID',
            then: (schema) => schema.required("Transações Pagas DEVEM possuir a 'Data Efetiva de Pagamento'"),
        }),
    cancellationDate: Yup.string()
        .matches(/^\d{4}-\d{2}-\d{2}$/, "Formato de data inválido (YYYY-MM-DD)")
        .nullable(),

    // Se está PAID, precisa saber onde caiu o dinheiro
    idBankAccount: Yup.string().when('status', {
        is: 'PAID',
        then: (schema) => schema.required("Contas liquidadas/pagas devem ser direcionadas a um Caixa/Banco (Ex: Inter / Recepção)"),
        otherwise: (schema) => schema.nullable()
    }),
    bankAccountName: Yup.string().nullable(),

    paymentMethod: Yup.string().oneOf(["CREDIT_CARD", "DEBIT_CARD", "PIX", "CASH", "BOLETO", "TRANSFER", "VOUCHER", "CHECK", "BALANCE", "OTHER"]).required(),
    currentInstallment: Yup.number().integer().min(1).default(1),
    totalInstallments: Yup.number().integer().min(1).default(1),
    documentNumber: Yup.string().nullable(),

    status: Yup.string().oneOf(["PENDING", "PAID", "OVERDUE", "CANCELED"]).default("PENDING"),
    
    cancellationReason: Yup.string().nullable(),
    notes: Yup.string().nullable()
});
